import React, { useState, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getCurrentSubdomain } from '../utils/subdomainTester';

const Navbar = ({ isDarkTheme }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navContainerRef = useRef(null);

  // Check if we're on an attorney subdomain
  const subdomain = getCurrentSubdomain();
  const isAttorneySubdomain = subdomain !== 'default' &&
                            subdomain !== 'www' &&
                            subdomain !== '' &&
                            subdomain !== null;

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Removed bone cursor effect for cleaner navigation experience

  return (
    <div className="nav-container" ref={navContainerRef}>
      <button
        className={`hamburger-menu ${isMenuOpen ? 'active' : ''}`}
        onClick={toggleMenu}
        aria-label="Toggle navigation menu"
        aria-expanded={isMenuOpen}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <nav className={`main-nav ${isMenuOpen ? 'active' : ''}`}>
        <ul>
          {/* Only show Home and Agent links if not on an attorney subdomain */}
          {!isAttorneySubdomain && (
            <>
              <li>
                <Link
                  to="/"
                  className={location.pathname === '/' ? 'active' : ''}
                  onClick={() => setIsMenuOpen(false)}
                  data-text="Home"
                >
                  <i className="nav-icon fas fa-home"></i>
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/demo"
                  className={location.pathname === '/demo' ? 'active' : ''}
                  onClick={() => setIsMenuOpen(false)}
                  data-text="Agent"
                >
                  <i className="nav-icon fas fa-gavel"></i>
                  Agent
                </Link>
              </li>
            </>
          )}
          {/* Always show About link */}
          <li>
            <Link
              to="/about"
              className={location.pathname === '/about' ? 'active' : ''}
              onClick={() => setIsMenuOpen(false)}
              data-text="About"
            >
              <i className="nav-icon fas fa-info-circle"></i>
              About
            </Link>
          </li>
        </ul>
      </nav>

      {/* Add overlay for mobile menu */}
      <div
        className={`nav-overlay ${isMenuOpen ? 'active' : ''}`}
        onClick={() => setIsMenuOpen(false)}
        aria-hidden="true"
      />
    </div>
  );
};

export default Navbar;